module.exports = __webpack_public_path__ + "img/icon-low-gas.38a6b36d.svg";